<div class="p-6">
  @if (error) {
    <div class="mb-4 p-3 rounded-lg bg-error-50 border border-error-200 text-sm text-error-700 dark:bg-error-500/10 dark:border-error-500/20 dark:text-error-400">
      {{ error }}
    </div>
  }

  <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">
    <!-- Canal -->
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Canal <span class="text-error-500">*</span>
      </label>
      @if (isEditing) {
        <div class="h-11 w-full rounded-lg border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 flex items-center">
          {{ channelLabel(form.get('channelType')?.value) }}
        </div>
        <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">El canal no se puede cambiar al editar.</p>
      } @else {
        <select
          formControlName="channelType"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
        >
          @for (ct of channelTypes; track ct.value) {
            <option [value]="ct.value">{{ ct.label }}</option>
          }
        </select>
      }
    </div>

    <!-- Empresa (alcance de la política) -->
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Empresa
      </label>
      @if (isEditing) {
        <div class="h-11 w-full rounded-lg border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 flex items-center">
          @if (form.get('intIdBussines')?.value === null || form.get('intIdBussines')?.value === undefined) {
            Global (todas las empresas)
          } @else {
            {{ businessName || 'Empresa específica' }}
          }
        </div>
        <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">El alcance no se puede cambiar al editar.</p>
      } @else {
        <input
          type="number"
          formControlName="intIdBussines"
          placeholder="Vacío = Global (todas las empresas)"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 border-gray-300"
        />
        <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">Dejar vacío para una política global.</p>
      }
    </div>

    <!-- Límite diario -->
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Límite diario <span class="text-error-500">*</span>
      </label>
      <input
        type="number"
        min="0"
        formControlName="dailyLimit"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
        [class.border-error-500]="hasError('dailyLimit')"
        [class.border-gray-300]="!hasError('dailyLimit')"
      />
      @if (hasError('dailyLimit')) {
        <p class="mt-1.5 text-sm text-error-500">{{ getError('dailyLimit') }}</p>
      }
    </div>

    <!-- Por minuto -->
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Límite por minuto <span class="text-error-500">*</span>
      </label>
      <input
        type="number"
        min="0"
        formControlName="perMinuteLimit"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
        [class.border-error-500]="hasError('perMinuteLimit')"
        [class.border-gray-300]="!hasError('perMinuteLimit')"
      />
      @if (hasError('perMinuteLimit')) {
        <p class="mt-1.5 text-sm text-error-500">{{ getError('perMinuteLimit') }}</p>
      }
    </div>

    <!-- Burst -->
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Burst
      </label>
      <input
        type="number"
        min="0"
        formControlName="burst"
        placeholder="Opcional"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
        [class.border-error-500]="hasError('burst')"
        [class.border-gray-300]="!hasError('burst')"
      />
      @if (hasError('burst')) {
        <p class="mt-1.5 text-sm text-error-500">{{ getError('burst') }}</p>
      }
    </div>

    <!-- Habilitada -->
    <div class="flex items-center gap-3">
      <input
        id="policyEnabled"
        type="checkbox"
        formControlName="enabled"
        class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500"
      />
      <label for="policyEnabled" class="text-sm text-gray-700 dark:text-gray-300">
        Habilitada
      </label>
    </div>

    <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
      <app-button variant="outline" type="button" (btnClick)="cancelar()">
        Cancelar
      </app-button>
      <app-button
        variant="primary"
        type="submit"
        [disabled]="saving || form.invalid"
      >
        {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear') }}
      </app-button>
    </div>
  </form>
</div>
